export default function Container({children, overflow = "auto", margin = 0}) {
    return (
        <div className={"shadow-sm border p-3 my-3 bg-white container-fluid mx-auto overflow-" + overflow}>
            {children}
        </div>
    );
};